import { resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import { computed, defineComponent, useCssModule, provide } from "vue";
import { Btn } from "linkd-ui";
//给导入的yqueryItem重新定义类型，不然报错
import YQueryItem1 from "./YQueryItem.vue";
const YQueryItem = YQueryItem1;
export default defineComponent({
  props: {
    searchText: {
      type: String,
      default: "搜索"
    },
    hasSearchButton: {
      type: Boolean,
      default: true
    },
    flexEnd: {
      type: Boolean,
      default: false
    },
    spaceBetween: {
      type: Boolean,
      default: true
    },
    equal: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    },
    gutter: {
      type: String,
      default: ""
    }
  },
  components: {
    Btn,
    YQueryItem
  },
  setup(props, ctx) {
    const css = useCssModule("css");
    //类名设置
    const queryClass = computed(() => {
      return {
        [css.query]: true,
        [css.flex_end]: props.flexEnd,
        [css.space_between]: props.spaceBetween
      };
    });
    //内容显示
    const content = computed(() => {
      let querycontent = [props.hasSearchButton ? _createVNode(_resolveComponent("y-query-item"), null, {
        default: () => [_createVNode(Btn, {
          "type": "primary",
          "onClick": el => {
            ctx.emit("search");
          }
        }, {
          default: () => [props.searchText]
        })]
      }) : null, ctx.slots.append?.()];
      if (props.spaceBetween) {
        querycontent = [_createVNode("div", {
          "class": css.q
        }, [ctx.slots.default?.()]), _createVNode("div", {
          "class": [css.q, css.bottom]
        }, [querycontent])];
      }
      return querycontent;
    });
    //子组件的size
    provide("size", props.size);
    provide("equal", props.equal);
    return () => _createVNode("div", {
      "style": {
        marginBottom: props.gutter
      },
      "class": queryClass.value
    }, [content.value]);
  }
});